import axios from "../axios/axios";
import { appSetAlert, appSetLoading } from "../store/actions/appAction";
import {
  setAccountCard,
  setBalanceSheetData,
  setBankTransactions,
  setBankTransactionsBank,
  setBuyByProducts,
  setBuysByFactor,
  setCapitals,
  setCreditorsAndDebtors,
  setFactorProfit,
  setFactorSummary,
  setJournals,
  setProductCard,
  setProfitAndLoss,
  setReportTransactions,
  setReviewAccounts,
  setSalesByFactor,
  setSellByProducts,
  setTaxReport,
  setTrialBalance, setUserLogs
} from "store/actions/reportAction";
import { errorDispatcher, getOptionsQuery, setSelectItemLabels } from "helpers";
import { setTableData } from "store/actions/dataTableAction";
import { DateToString } from "../components/Reports/DateFilter";
import fileDownload from "js-file-download";
import { getQueryParam } from "helpers/queryParam";
import { options } from "assets/js/widgetItems";

export function getPrefix(options = [], pagination) {
  let query = "";
  if (options && Array.isArray(options)) {
    const opts = pagination
      ? [...options, { key: "limit", value: pagination.limit }, { key: "page", value: pagination.page }]
      : options;

    query += "?";
    let flag = true;
    opts.map((option, i) => {
      if (option && option.key && option.value && option.key !== "undefined") {
        if (!flag) {
          query += "&";
        } else {
          flag = false;
        }
        query += `${option.key}=${option.value}`;
      }
    });
  } else if (pagination) {
    const opts = [
      { key: "limit", value: pagination.limit },
      { key: "page", value: pagination.page },
    ];
    if (Object.keys(options).length) {
      opts.concat(...options)
    }
    query += "?";
    let flag = true;
    opts.map((option, i) => {
      if (option && option.key && option.value && option.key !== "undefined") {
        if (!flag) {
          query += "&";
        } else {
          flag = false;
        }
        query += `${option.key}=${option.value}`;
      }
    });
  }
  return query;
}

export const apiGetBalanceSheet = (token, params) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  axios
    .get(`/reports/balanceSheet`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    })
    .then((response) => {
      dispatch(setBalanceSheetData(response.data.balanceSheet));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetReportProfitAndLoss = (token, params) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  axios
    .get(`/reports/profitAndLoss`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    })
    .then((response) => {
      dispatch(setProfitAndLoss(response.data.profitAndLoss));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetTrialBalance = (token, params) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  const columnNumber = getQueryParam("columnNumber")
  const rightLevel = getQueryParam("rightLevel")
  axios
    .post(`/reports/trialBalance`, { columnNumber: columnNumber ? columnNumber : "2", rightLevel: rightLevel ? rightLevel : null, ...params }, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setTrialBalance(response.data.trialBalance, response.data.sumAmountFinal));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetJournals =
  ({ pagination, token, key, sort, search, options }) =>
    (dispatch, getState) => {
      // const opts = pagination
      //   ? [...options, { key: "limit", value: pagination.limit }, { key: "page", value: pagination.page }]
      //   : options;
      // let url = `/reports/journal${getPrefix(opts)}`;
      let url = `/reports/journal`;
      let params = { ...options, ...getOptionsQuery(pagination, search, sort) };

      dispatch(appSetLoading(true));
      axios
        .post(url, params, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.journal, response.data.paginate));
          }

          const journals = setSelectItemLabels(response.data.journal, "id", "nickName");
          dispatch(setJournals(journals));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetInstallmentsReport =
  ({ pagination, options, sort, search, type, status, filters }) =>
    (dispatch, getState) => {
      const token = getState().businessReducer.business?.token;
      const statuss = getQueryParam("status")
      type = getQueryParam("type")
      status = statuss.split("_")[0]
      let url = `/reports/installment/accountCard?type=${type}&status=${status}`;
      options = { ...options, filters, ...getOptionsQuery(pagination, search, sort) };

      dispatch(appSetLoading(true));
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {

          dispatch(setTableData(response.data?.installmentItems, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));


          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetBankTransactions =
  ({ pagination, token, options, sort, search, id, tab }) =>
    (dispatch, getState) => {
      let bankId = id;
      if (!bankId && options?.search) {
        let queryParams = options.search.split("=");
        bankId = queryParams.length > 1 ? queryParams[1] : 0;
      }

      if (!bankId) return;
      let url = `/reports/bankTransactions/${tab || ""}`;
      options = { ...options, ...getOptionsQuery(pagination, search, sort) };

      dispatch(appSetLoading(true));
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
          params: { bankId },
        })
        .then((response) => {
          if (pagination) {
            if (tab === "cheques") {
              dispatch(setTableData(response.data?.financial?.cheques, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
            } else {
              const bankTransactions = setSelectItemLabels(
                response.data?.bankTransactions?.bankTransactions,
                "id",
                "nickName"
              );
              dispatch(setBankTransactions(bankTransactions));
              dispatch(setTableData(response.data?.bankTransactions?.bankTransactions, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
            }
          }

          !!response.data.bank && dispatch(setBankTransactionsBank(response.data.bank));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiSetBankTransactionApproved =
  ({ id, approved, token }) =>
    (dispatch, getState) => {
      const tableData = getState().dataTableReducer?.items;
      const url = "/accountings/update/approve";
      axios
        .put(
          url,
          { accountingIds: [id], approved },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          const newTableData = tableData.map((x) => {
            if (x.id === id) {
              return { ...x, approved };
            }
            return x;
          });
          const paginationReducer = getState().dataTableReducer.paginate

          dispatch(setTableData(newTableData, paginationReducer));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiGetFundTransactions =
  ({ pagination, token, options, sort, search, id }) =>
    (dispatch, getState) => {
      let fundId = id;
      if (!fundId && options?.search) {
        let queryParams = options.search.split("=");
        fundId = queryParams.length > 1 ? queryParams[1] : 0;
      }

      if (!fundId) {
        return;
      }

      let url = `/reports/fundTransactions?fundId=${fundId}`;
      options = { ...options, ...getOptionsQuery(pagination, search, sort) };

      dispatch(appSetLoading(true));
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data?.fundTransactions?.fundTransactions, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
          }

          const bankTransactions = setSelectItemLabels(
            response.data?.fundTransactions?.fundTransactions,
            "id",
            "nickName"
          );
          dispatch(setBankTransactions(bankTransactions));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiGetCashierTransactions =
  ({ pagination, token, options, sort, search, id }) =>
    (dispatch, getState) => {
      let cashierId = id;
      if (!cashierId && options?.search) {
        let queryParams = options.search.split("=");
        cashierId = queryParams.length > 1 ? queryParams[1] : 0;
      }

      if (!cashierId) {
        return;
      }

      let url = `/reports/cashierTransactions?cashierId=${cashierId}`;
      options = { ...options, ...getOptionsQuery(pagination, search, sort) };

      dispatch(appSetLoading(true));
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(
              setTableData(response.data?.cashierTransactions?.cashierTransactions, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal)
            );
          }

          const bankTransactions = setSelectItemLabels(
            response.data?.cashierTransactions?.cashierTransactions,
            "id",
            "nickName"
          );
          dispatch(setBankTransactions(bankTransactions));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiGetDebtorsAndCreditors =
  ({ pagination, token, search, sort, options }) =>
    (dispatch, getState) => {
      let url = `/reports/debtorsCreditors`;
      let params = { ...options, ...getOptionsQuery(pagination, search, sort) }

      dispatch(appSetLoading(true));
      axios
        .post(url, params, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.debtorsCreditors.debtorsCreditors, response.data.paginate, response.data?.sumAmount, response.data?.sumAmountFinal));
          }

          const debtorsCreditors = setSelectItemLabels(response.data.debtorsCreditors, "id", "nickName");
          dispatch(setCreditorsAndDebtors(debtorsCreditors));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetUserLogs =
  ({ pagination, token, options }) =>
    (dispatch, getState) => {
      let url = `/reports/test/userLog${getPrefix(options, pagination)}`;
      if (pagination) {
        url += `?limit=${pagination.limit}&page=${pagination.page}`;
      }

      dispatch(appSetLoading(true));
      axios
        .get(url, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.userLogs, response.data.paginate));
          }

          const userLogs = setSelectItemLabels(response.data.userLogs, "id", "nickName");
          dispatch(setUserLogs(userLogs));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetFactorSummary =
  ({ pagination, token, options, search, sort }) =>
    (dispatch, getState) => {
      let url = `/reports/factorSummary${getPrefix(search, pagination)}&factorType=sale`;

      dispatch(appSetLoading(true));
      let params = { ...options, ...getOptionsQuery(pagination, search, sort) };

      axios
        .post(url, params, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.factorSummary, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
          }

          const factorSummary = setSelectItemLabels(response.data.factorSummary, "id", "nickName");
          dispatch(setFactorSummary(factorSummary));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetAccountTypeBylevel = ({ params, pagination }) =>
  (dispatch, getState) => {
    const token = getState().businessReducer.business?.token;
    params = { ...getOptionsQuery(pagination, {}, {}), ...params }

    dispatch(appSetLoading(true));
    axios
      .post('/reports/reviewAccounts/levels', params, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (pagination) {
          dispatch(setTableData(response.data.data));
        }

        // const saleByProducts = setSelectItemLabels(response.data, "id", "nickName");
        // dispatch(setSellByProducts(saleByProducts));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });


  }
export const apiGetSellByProducts =
  ({ pagination, token, key, sort, search, options }) =>
    (dispatch, getState) => {
      let params = getOptionsQuery(pagination, search, sort);
      Object.assign(params, options)
      let url = `/reports/saleByProducts${getPrefix([], pagination)}`;
      dispatch(appSetLoading(true));
      axios
        .post(url, params, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.saleByProducts, response.data.paginate, response.data.sumAmount));
          }

          const saleByProducts = setSelectItemLabels(response.data, "id", "nickName");
          dispatch(setSellByProducts(saleByProducts));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetproductProfit = ({ pagination, token, key, sort, search, options }) =>
  (dispatch, getState) => {
    let params = { ...options, ...getOptionsQuery(pagination, search, sort) };
    let url = `/reports/productProfit${getPrefix([], pagination)}`;

    dispatch(appSetLoading(true));
    axios
      .post(url, params, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (pagination) {
          dispatch(setTableData(response.data.profitProduct
            , response.data.paginate));
        }

        const saleByProducts = setSelectItemLabels(response.data, "id", "nickName");
        dispatch(setSellByProducts(saleByProducts));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  }
export const apiGetBuyByProducts =
  ({ pagination, token, key, sort, search, options }) =>
    (dispatch, getState) => {
      let params = { ...getOptionsQuery(pagination, search, sort), ...options }
      let url = `/reports/buyByProducts${getPrefix([], pagination)}`;

      dispatch(appSetLoading(true));
      axios
        .post(url, params, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.buyByProducts, response.data.paginate, response.data.sumAmount));
          }

          const buyByProducts = setSelectItemLabels(response.data, "id", "nickName");
          dispatch(setBuyByProducts(buyByProducts));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiGetReportTransActions =
  ({ pagination, key, sort, search, id, options }) =>
    (dispatch, getState) => {
      const token = getState().businessReducer.business.token
      let url = `/reports/transactions`;
      const Url_Window = window.location.search
      const params = new URLSearchParams(Url_Window);
      Object.assign(params, key)
      let accountTypeId = params.get("accountTypeId");
      if (!accountTypeId) {
        return
      }

      url += `?accountTypeId=${accountTypeId}`;
      let optionss = getOptionsQuery(pagination, search, sort);
      Object.assign(optionss, options)
      dispatch(appSetLoading(true));
      axios
        .post(url, optionss, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.transactions, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
          }

          const transactions = setSelectItemLabels(response.data.transactions, "id", "nickName");
          dispatch(setReportTransactions(transactions));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetSalaryByPersons =
  ({ pagination, key, sort, search, id, options }) =>
    (dispatch, getState) => {
      const personId = getQueryParam("personId")
      // if (personId === null) return dispatch(appSetAlert("شخص را انتخاب نمایید", "error"));
      const token = getState().businessReducer.business?.token;

      dispatch(appSetLoading(true));
      axios.post(`/accountings/salary/index`, { ...options, personId, ...getOptionsQuery(pagination, search, sort) }, {
        headers: { Authorization: `Bearer ${token}` },
      }).then((response) => {
        if (pagination) {
          dispatch(setTableData(response.data.accountings, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
        }
      }).finally(() => {
        dispatch(appSetLoading(false));
      })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    }

export const apiGetSalaryReportItems =
  ({ accountingId, callBack }) =>
    (dispatch, getState) => {
      const token = getState().businessReducer.business?.token;
      dispatch(appSetLoading(true));
      axios.get(`/accountings/salary/${accountingId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(res => {
        dispatch(appSetLoading(false));
        callBack(res.data)
      }).catch(err => {
        dispatch(appSetLoading(false));
        errorDispatcher(err, dispatch);
      })
    }


export const apiGetTaxReports =
  ({ pagination, token, options, type }) =>
    (dispatch, getState) => {
      let url = `/reports/taxReport${getPrefix(options, pagination)}`;
      const params = {
        factorType: type || "sale",
      };

      dispatch(appSetLoading(true));
      axios
        .get(url, {
          headers: { Authorization: `Bearer ${token}` },
          params,
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.taxReport, response.data.paginate));
          }

          const taxReport = setSelectItemLabels(response.data, "id", "nickName");
          dispatch(setTaxReport(taxReport));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiGetSalesByFactor =
  ({ pagination, sort, search, id, location, options }) =>
    (dispatch, getState) => {
      const token = getState().businessReducer.business.token
      let productId = id;
      if (!productId && location?.search) {
        let queryParams = location.search.split("=");
        productId = queryParams.length > 1 ? queryParams[1] : 0;
      }
      let params = { ...getOptionsQuery(pagination, search, sort), ...options };
      let url = `/reports/salesByFactor${getPrefix([], pagination)}`;

      if (productId) {
        url += `&productId=${productId}`;
      } else {
        dispatch(setSalesByFactor(null));
        return dispatch(setTableData({ error: "برای مشاهده این گزارش یک کالا انتخاب کنید" }, pagination));
      }

      dispatch(appSetLoading(true));
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.salesByFactor, response.data.paginate));
          }

          const salesByFactor = setSelectItemLabels(response.data, "id", "nickName");
          dispatch(setSalesByFactor(salesByFactor));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiGetFactorProfit =
  ({ pagination, token, options, sort, search, id, location }) =>
    (dispatch, getState) => {
      let params = options;
      let personId = id;
      if (!personId && location) {
        let queryParams = location.search.split("=");
        personId = queryParams.length > 1 ? queryParams[1] : 0;
      }

      let url = `/reports/factorProfit${getPrefix(options, pagination)}`;

      if (personId) {
        url += `&personId=${personId}`;
      } else {
        dispatch(setFactorProfit([]));
        dispatch(setTableData({ error: "برای مشاهده این گزارش یک شخص انتخاب کنید" }, pagination));
        return;
      }

      dispatch(appSetLoading(true));
      axios
        .get(url, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.factorProfit, response.data.paginate));
          }

          const factorProfit = setSelectItemLabels(response.data, "id", "nickName");
          dispatch(setFactorProfit(factorProfit));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetCountSaleBuy = ({ type, personId, callBack }) => (dispatch, getState) => {
  const token = getState().businessReducer.business?.token;
  //dispatch(appSetLoading(true));
  axios.post(`/reports/person/accountCard/factorDetail`, { type, personId }, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
    callBack(res.data)
  }).catch(err => errorDispatcher(err, dispatch)).finally(() => {
    // dispatch(appSetLoading(false));

  })
}
export const apiGetAccountCard =
  ({ pagination, token, options, params, sort, search, tab, callBack }) =>
    (dispatch, getState) => {
      let url = `/reports/person/accountCard/${tab || "transactions"}`;
      const personId = location.search.split("=")[1];
      if (!personId) {
        dispatch(setAccountCard(null));
        return dispatch(setTableData({ error: "برای مشاهده این گزارش یک شخص انتخاب کنید" }, pagination));
      }
      options = { ...getOptionsQuery(pagination, search, sort), ...options };
      params = { ...params, personId }
      dispatch(appSetLoading(true));
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
          params,
        })
        .then((response) => {
          if (pagination) {
            const person = response.data?.person;
            let res = person.Accounting_Items;
            if (tab === "factors" && person.products) res = person.products;
            if (tab === "cheques" && person.cheques) res = person.cheques;
            dispatch(setTableData(res, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
          }
          const person = setSelectItemLabels(response.data?.person, "id", "nickName");

          dispatch(setAccountCard(person));
          dispatch(appSetLoading(false));
          callBack(response)
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
// export const apiGetPersonAccountCardTransactions = (pagination, token, options, sort, searchQuery, params, personId) => (dispatch, getState) => {
//     if (!personId && params?.search) {
//         let queryParams = params.search.split('=')
//         personId = queryParams.length > 1 ? queryParams[1] : 0
//     }
//
//     let url = `/reports/person/accountCard/transactions${getPrefix(options, pagination)}`;
//
//     if (personId) {
//         url += `&personId=${personId}`;
//     } else {
//         dispatch(setAccountCard(null));
//         dispatch(setTableData({error: "برای مشاهده این گزارش یک شخص انتخاب کنید"}, pagination));
//         return
//     }
//
//     dispatch(appSetLoading(true));
//     axios
//         .get(url, {
//             headers: {Authorization: `Bearer ${token}`},
//         })
//         .then((response) => {
//             if (pagination) {
//                 dispatch(setTableData(response.data?.personFind?.Accounting_Items, response.data.paginate));
//             }
//
//             const person = setSelectItemLabels(response.data?.person, "id", "nickName");
//             dispatch(setAccountCard(person));
//             dispatch(appSetLoading(false));
//         })
//         .catch((error) => {
//             errorDispatcher(error, dispatch);
//         });
// };
export const apiGetPersonAccountCardProducts =
  (pagination, token, options, sort, searchQuery, params, personId) => (dispatch, getState) => {
    if (!personId && params?.search) {
      let queryParams = params.search.split("=");
      personId = queryParams.length > 1 ? queryParams[1] : 0;
    }

    let url = `/reports/person/accountCard/factor${getPrefix(options, pagination)}`;

    if (personId) {
      url += `&personId=${personId}`;
    } else {
      dispatch(setAccountCard(null));
      dispatch(setTableData({ error: "برای مشاهده این گزارش یک شخص انتخاب کنید" }, pagination));
      return;
    }

    dispatch(appSetLoading(true));
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (pagination) {
          dispatch(setTableData(response.data?.person?.products, response.data.paginate));
        }

        const person = setSelectItemLabels(response.data?.person, "id", "nickName");
        dispatch(setAccountCard(person));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };
export const apiGetPersonAccountCardCheques =
  ({ pagination, token, options, params, sort, search, tab }) => (dispatch, getState) => {
    const personId = location.search.split("=")[1];
    if (!personId) {
      dispatch(setAccountCard(null));
      return dispatch(setTableData({ error: "برای مشاهده این گزارش یک شخص انتخاب کنید" }, pagination));
    }

    let url = `/reports/person/accountCard/cheques`;


    options = { ...getOptionsQuery(pagination, search, sort), ...options };
    params = { ...params, personId }
    dispatch(appSetLoading(true));
    axios
      .post(url, options, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        if (pagination) {
          const person = response.data?.person.cheques;

          dispatch(setTableData(person, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
        }
        const person = setSelectItemLabels(response.data?.person, "id", "nickName");

        dispatch(setAccountCard(person));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });

  };
export const apiGetPersonAccountCardBills =
  ({ pagination, token, options, params, sort, search, tab }) => (dispatch, getState) => {
    const personId = location.search.split("=")[1];
    if (!personId) {
      dispatch(setAccountCard(null));
      return dispatch(setTableData({ error: "برای مشاهده این گزارش یک شخص انتخاب کنید" }, pagination));
    }

    let url = `/reports/person/accountCard/bills/detail`;


    options = { ...getOptionsQuery(pagination, search, sort), ...options };
    params = { ...params, personId }
    dispatch(appSetLoading(true));
    axios
      .post(url, options, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        if (pagination) {
          const person = response.data?.data;

          dispatch(setTableData(person, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
        }
        const person = setSelectItemLabels(response.data?.person, "id", "nickName");

        dispatch(setAccountCard(person));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });

  };
export const apiGetPersonAccountCardFactors =
  ({ pagination, token, options, params, sort, search, tab }) => (dispatch, getState) => {
    const personId = location.search.split("=")[1];
    if (!personId) {
      dispatch(setAccountCard(null));
      return dispatch(setTableData({ error: "برای مشاهده این گزارش یک شخص انتخاب کنید" }, pagination));
    }

    let url = `/reports/person/accountCard/factors`;


    options = { ...getOptionsQuery(pagination, search, sort), ...options };
    params = { ...params, personId }
    dispatch(appSetLoading(true));
    axios
      .post(url, options, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        if (pagination) {
          const person = response.data?.person.products;

          dispatch(setTableData(person, response.data.paginate, response.data.sumAmount, response.data.sumAmountFinal));
        }
        const person = setSelectItemLabels(response.data?.person, "id", "nickName");

        dispatch(setAccountCard(person));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });

  };

export const apiGetProductAccountCard =
  ({ pagination, token, options, params, sort, search, tab }) =>
    (dispatch, getState) => {
      let url = `/reports/product/accountCard/${tab || "factors"}`;

      if (!params.productId) {
        dispatch(setAccountCard(null));
        return dispatch(setTableData({ error: "برای مشاهده این گزارش یک کالا انتخاب کنید" }, pagination));
      }

      options = { ...getOptionsQuery(pagination, search, sort), ...options };

      dispatch(appSetLoading(true));
      axios
        .post(url, options, {
          headers: { Authorization: `Bearer ${token}` },
          params,
        })
        .then((response) => {
          if (pagination) {
            let items = [];
            if (response.data?.accountingItems) {
              items = response.data.accountingItems;
              let balance = 0;
              items = items.map((x) => {
                balance = x.logIn ? balance + x.logIn : x.logOut ? balance - x.logOut : balance;
                return { ...x, balance };
              });
            }
            if (response.data?.product && response.data?.product?.persons) {
              for (const row of response.data.product?.persons) {
                row['unit'] = response.data.product.unit
              }
              items = response.data.product?.persons
            }
            if (response.data?.product && response.data?.product?.Product_Bills) {
              items = response.data.product.Product_Bills;
              // let balance = 0;
              // items = items.map((x) => {
              //   balance = balance + x.quantity;
              //   return { ...x, balance };
              // });
            }
            dispatch(setTableData(items, response.data.paginate));
          }

          const product = setSelectItemLabels(response.data?.product, "id", "nickName");
          if (response.data?.product) dispatch(setProductCard(product));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetProjectAccountCardFactors = async (props) => {
  let { pagination, token, tab, cb, search, sort, options } = props;
  let params = options;
  let url = "/reports/project/accountCard/factorsInfo" + (tab ? `/${tab}` : "");
  // if (pagination) params = {...params, ...pagination};
  if (!params) return;
  if (!params.projectId) {
    dispatch(setAccountCard(null));
    return dispatch(setTableData({ error: "برای مشاهده این گزارش یک شعبه انتخاب کنید" }, pagination));
  } else {
    url += `?projectId=${options.projectId}`;
  }

  options = getOptionsQuery(pagination, search, sort);

  const result = await axios.post(url, options, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return result

}
export const apiGetProjectAccountCardPersonInfo = async (props) => {
  let { pagination, token, tab, cb, search, sort, options } = props;
  let params = options;
  let url = "/reports/project/accountCard/personsInfo" + (tab ? `/${tab}` : "");
  // if (pagination) params = {...params, ...pagination};
  if (!params) return;
  if (!params.projectId) {
    dispatch(setAccountCard(null));
    return dispatch(setTableData({ error: "برای مشاهده این گزارش یک شعبه انتخاب کنید" }, pagination));
  } else {
    url += `?projectId=${options.projectId}`;
  }

  Object.assign(params, getOptionsQuery(pagination, search, sort))

  const result = await axios.post(url, params, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return result
}
export const apiGetProjectAccountCard = (props) => (dispatch, getState) => {
  let { pagination, token, tab, cb, search, sort, options } = props;
  let params = options;
  let url = "/reports/project/accountCard" + (tab ? `/${tab}` : "");
  // if (pagination) params = {...params, ...pagination};
  if (!params) return;
  if (!params.projectId) {
    dispatch(setAccountCard(null));
    return dispatch(setTableData({ error: "برای مشاهده این گزارش یک پروژه انتخاب کنید" }, pagination));
  } else {
    url += `?projectId=${options.projectId}`;
  }

  Object.assign(params, getOptionsQuery(pagination, search, sort))

  dispatch(appSetLoading(true));
  axios
    .post(url, params, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(async (response) => {
      let items = response?.data?.data;
      if (pagination && items) {
        if (tab === "bills") {
          let balance = 0;
          items = items.map((x) => {
            balance = balance + x.quantity;
            return { ...x, balance };
          });
        }

        dispatch(setTableData(items, response.data.paginate));
      }
      if (!params.onlyTable) {
        const FactorsInfo = await apiGetProjectAccountCardFactors(props)
        const PersonInfo = await apiGetProjectAccountCardPersonInfo(props)
        response.data.accountCard = {
          ...response.data.accountCard
          , ...FactorsInfo.data.data, ...PersonInfo.data.data
        }
      }

      if (cb) cb(response);
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetBranchAccountCardFactors = async (props) => {
  let { pagination, token, tab, cb, search, sort, options } = props;
  let params = options;
  let url = "/reports/branch/accountCard/factorsInfo" + (tab ? `/${tab}` : "");
  // if (pagination) params = {...params, ...pagination};
  if (!params) return;
  if (!params.branchId) {
    dispatch(setAccountCard(null));
    return dispatch(setTableData({ error: "برای مشاهده این گزارش یک شعبه انتخاب کنید" }, pagination));
  } else {
    url += `?branchId=${options.branchId}`;
  }

  Object.assign(params, getOptionsQuery(pagination, search, sort))

  const result = await axios.post(url, params, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return result

}
export const apiGetBranchAccountCardPersonInfo = async (props) => {
  let { pagination, token, tab, cb, search, sort, options } = props;
  let params = options;
  let url = "/reports/branch/accountCard/personsInfo" + (tab ? `/${tab}` : "");
  // if (pagination) params = {...params, ...pagination};
  if (!params) return;
  if (!params.branchId) {
    dispatch(setAccountCard(null));
    return dispatch(setTableData({ error: "برای مشاهده این گزارش یک شعبه انتخاب کنید" }, pagination));
  } else {
    url += `?branchId=${options.branchId}`;
  }

  Object.assign(params, getOptionsQuery(pagination, search, sort))

  const result = await axios.post(url, params, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return result

}
export const apiGetBranchAccountCard = (props) => (dispatch, getState) => {
  let { pagination, token, tab, cb, search, sort, options } = props;
  let params = options;
  let url = "/reports/branch/accountCard" + (tab ? `/${tab}` : "");
  // if (pagination) params = {...params, ...pagination};
  if (!params) return;
  if (!params.branchId) {
    dispatch(setAccountCard(null));
    return dispatch(setTableData({ error: "برای مشاهده این گزارش یک شعبه انتخاب کنید" }, pagination));
  } else {
    url += `?branchId=${options.branchId}`;
  }

  Object.assign(params, getOptionsQuery(pagination, search, sort))

  dispatch(appSetLoading(true));
  axios
    .post(url, params, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(async (response) => {
      let items = response?.data?.data;
      if (pagination && items) {
        if (tab === "bills") {
          let balance = 0;
          items = items.map((x) => {
            balance = balance + x.quantity;
            return { ...x, balance };
          });
        }

        dispatch(setTableData(items, response.data.paginate));
      }
      if (!params.onlyTable) {
        const FactorsInfo = await apiGetBranchAccountCardFactors(props)
        const PersonInfo = await apiGetBranchAccountCardPersonInfo(props)
        response.data.data = { ...response.data.data, ...FactorsInfo.data.data, ...PersonInfo.data.data }
      }
      if (cb) cb(response);
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetProductCard =
  (pagination, token, options, sort, searchQuery, params, productId) => (dispatch, getState) => {
    if (!productId && params?.search) {
      let queryParams = params.search.split("=");
      productId = queryParams.length > 1 ? queryParams[1] : 0;
    }

    let url = `/reports/product/accountCard/factors${getPrefix(options, pagination)}`;

    if (productId) {
      url += `&productId=${productId}`;
    } else {
      dispatch(setProductCard(null));
      return dispatch(setTableData({ error: "برای مشاهده این گزارش یک کالا انتخاب کنید" }, pagination));
    }

    dispatch(appSetLoading(true));
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (pagination) {
          dispatch(setTableData(response.data?.accountingItems, response.data.paginate));
        }

        const product = setSelectItemLabels(response.data?.product, "id", "nickName");
        dispatch(setProductCard(product));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };
export const apiGetProductCardPersons =
  (pagination, token, options, sort, searchQuery, params, productId) => (dispatch, getState) => {
    if (!productId && params?.search) {
      let queryParams = params.search.split("=");
      productId = queryParams.length > 1 ? queryParams[1] : 0;
    }

    let url = `/reports/product/accountCard/persons${getPrefix(options, pagination)}`;

    if (productId) {
      url += `&productId=${productId}`;
    } else {
      dispatch(setProductCard(null));
      return dispatch(setTableData({ error: "برای مشاهده این گزارش یک کالا انتخاب کنید" }, pagination));
    }

    dispatch(appSetLoading(true));
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (pagination) {
          dispatch(setTableData(response.data?.accountingItems, response.data.paginate));
        }

        const product = setSelectItemLabels(response.data?.product, "id", "nickName");
        dispatch(setProductCard(product));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };
export const apiGetProductCardRemittances =
  (pagination, token, options, sort, searchQuery, params, productId) => (dispatch, getState) => {
    if (!productId && params?.search) {
      let queryParams = params.search.split("=");
      productId = queryParams.length > 1 ? queryParams[1] : 0;
    }

    let url = `/reports/product/accountCard/bills${getPrefix(options, pagination)}`;

    if (productId) {
      url += `&productId=${productId}`;
    } else {
      dispatch(setProductCard(null));
      return dispatch(setTableData({ error: "برای مشاهده این گزارش یک کالا انتخاب کنید" }, pagination));
    }

    dispatch(appSetLoading(true));
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (pagination) {
          dispatch(setTableData(response.data?.accountingItems, response.data.paginate));
        }

        const product = setSelectItemLabels(response.data?.product, "id", "nickName");
        dispatch(setProductCard(product));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiGetBuysByFactor =
  ({ pagination, token, options, sort, search, id, location }) =>
    (dispatch, getState) => {
      let productId = id;
      if (!productId && location?.search) {
        let queryParams = location.search.split("=");
        productId = queryParams.length > 1 ? queryParams[1] : 0;
      }
      let params = { ...options, ...getOptionsQuery(pagination, search, sort) };
      let url = `/reports/buysByFactor${getPrefix([], pagination)}`;

      if (productId) {
        url += `&productId=${productId}`;
      } else {
        dispatch(setBuysByFactor(null));
        return dispatch(setTableData({ error: "برای مشاهده این گزارش یک کالا انتخاب کنید" }, pagination));
      }

      dispatch(appSetLoading(true));
      axios
        .post(url, params, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (pagination) {
            dispatch(setTableData(response.data.buysByFactor, response.data.paginate));
          }

          const buysByFactor = setSelectItemLabels(response.data, "id", "nickName");
          dispatch(setBuysByFactor(buysByFactor));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiGetCapitals =
  ({ pagination, token, options, search, sort }) =>
    (dispatch, getState) => {
      let params = { ...options, ...getOptionsQuery(pagination, search, sort) };

      let url = `/reports/capitalStatement${getPrefix(options)}`;
      dispatch(appSetLoading(true));

      axios
        .post(url, params, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          dispatch(setTableData(response.data.capitalStatement, response.data.paginate));
          const capitals = setSelectItemLabels(response.data.capitalStatement, "id", "nickName");
          dispatch(setCapitals(capitals));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetGardesh = ({ pagination, token, search, sort, options }) => (dispatch, getState) => {
  let url = `/reports/reviewAccounts/accountings`;
  const rightLevel = getQueryParam("rightLevel");
  const topLevel = getQueryParam("topLevel")
  if (!rightLevel) return
  const selectedRows = getState().selectBoxTableValueReducer.selectedIds["reviewAccount"]
  let params = { topLevel, rightLevel, rightLevelIds: selectedRows, ...options, ...getOptionsQuery(pagination, search, sort) };

  dispatch(appSetLoading(true));
  axios
    .post(url, params, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setTableData(response?.data?.data, response.data.paginate));

      // const reviewAccounts = setSelectItemLabels(response?.data?.transactions, "id", "nickName");
      // dispatch(setReviewAccounts(reviewAccounts));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });

}
export const apiGetReviewAccounts =
  ({ pagination, token, search, sort, options }) =>
    (dispatch, getState) => {
      let url = `/reports/reviewAccounts${getPrefix(options)}`;
      const rightLevel = getQueryParam("rightLevel");
      const topLevel = getQueryParam("topLevel")
      if (!rightLevel) return
      const selectedRows = getState().selectBoxTableValueReducer.selectedIds["reviewAccount"]
      let params = { topLevel, rightLevel, rightLevelIds: selectedRows, ...options, ...getOptionsQuery(pagination, search, sort) };

      dispatch(appSetLoading(true));
      axios
        .post(url, params, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          dispatch(setTableData(response?.data?.reviewAccounts?.childs, response.data.paginate));

          const reviewAccounts = setSelectItemLabels(response?.data?.reviewAccounts?.childs, "id", "nickName");
          dispatch(setReviewAccounts(reviewAccounts));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiGetFactorWithDetailExcel = (token, personId) => (dispatch, getState) => {
  if (!personId) {
    dispatch(setAccountCard(null));
    return dispatch(setTableData({ error: "برای دریافت این فایل یک شخص را انتخاب کنید" }));
  }
  let url = `reports/person/accountCard/excelExportFactorsDetail`;
  dispatch(appSetLoading(true));
  axios.post(url, {},
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
      params: {
        personId: personId
      }
    }
  ).then((response) => {
    dispatch(appSetLoading(false));
    const now = DateToString(Date.now()).replace("/", "_");
    const fileName = `factorsWithDetail_${now}`;
    fileDownload(response.data, `${fileName}.xlsx`);
  })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
